import { gql, useApolloClient, useMutation } from '@apollo/client'

import {
  DeactivateUserMutation,
  DeactivateUserMutationVariables,
} from '@/clients/utoniq-core/schema'
import { useAuth, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { clearStorage } from '@/core/native/storage'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router, routerPages } = useRouter()
  const { logout } = useAuth()
  const client = useApolloClient()

  const [deactivateUser] = useMutation<
    DeactivateUserMutation,
    DeactivateUserMutationVariables
  >(DEACTIVATE_USER)

  return {
    state: {},
    actions: {
      async onSubmit({ reasonNumber, otherReason, opinion }) {
        await deactivateUser({
          variables: {
            input: {
              reasonNumber: +reasonNumber,
              otherReason: otherReason || undefined,
              opinion,
            },
          },
        })
        await Promise.all([logout(), client.clearStore(), clearStorage()])
        router.push(routerPages.DeactivationCompletion)
      },
    },
  }
})

const DEACTIVATE_USER = gql`
  mutation DeactivateUser($input: DeactivateUserInput!) {
    deactivateUser(inputs: $input) {
      id
    }
  }
`
